module.exports = __webpack_public_path__ + "assets/close-2.609e33f6.svg";